const setTheme = (
  isSubdomain: boolean,
  whiteLabelConfig?: {
    primaryColor?: string;
    primaryContrastText?: string;
    secondaryColor?: string;
    bgColor?: string;
    bgColorContrastText?: string;
    lightBackgroundIconColor?: string;
    bgColorAlternate?: string;
    bgColorAlternateContrastText?: string;
    primaryHoverColor?: string;
  },
) => {
  // whiteLabelConfig can be undefined if accessed via browserless/ngrok
  if (isSubdomain && whiteLabelConfig) {
    const {
      primaryColor = '',
      primaryContrastText = '',
      secondaryColor = '',
      bgColor = '',
      bgColorAlternate = '',
      bgColorContrastText = '',
      primaryHoverColor = '',
      bgColorAlternateContrastText = '',
      lightBackgroundIconColor = '',
    } = whiteLabelConfig;
    document.documentElement.style.setProperty('--primary-color', bgColor);
    document.documentElement.style.setProperty(
      '--primary-color-contrast-text',
      bgColorContrastText,
    );
    document.documentElement.style.setProperty(
      '--button-text-color',
      primaryColor || 'black',
    );
    document.documentElement.style.setProperty(
      '--button-contrast-text',
      primaryContrastText || 'white',
    );
    document.documentElement.style.setProperty(
      '--button-text-hover-color',
      primaryHoverColor || 'black',
    );
    document.documentElement.style.setProperty(
      '--account-icon-color-onboarding',
      secondaryColor,
    );
    document.documentElement.style.setProperty(
      '--account-icon-color-portal',
      lightBackgroundIconColor,
    );
    document.documentElement.style.setProperty(
      '--primary-card-color',
      bgColorAlternate,
    );
    document.documentElement.style.setProperty(
      '--primary-card-color-contrast-text',
      bgColorAlternateContrastText,
    );
  } else {
    document.documentElement.style.setProperty('--primary-color', '#f0e9e6');
    document.documentElement.style.setProperty(
      '--primary-color-contrast-text',
      '#ffffff',
    );
    document.documentElement.style.setProperty(
      '--button-text-color',
      '#56b26c',
    );
    document.documentElement.style.setProperty(
      '--button-contrast-text',
      '#ffffff',
    );
    document.documentElement.style.setProperty(
      '--button-text-hover-color',
      '#468d56',
    );
    document.documentElement.style.setProperty(
      '--account-icon-color-onboarding',
      '#56b26c',
    );
    document.documentElement.style.setProperty(
      '--account-icon-color-portal',
      '#56b26c',
    );
    document.documentElement.style.setProperty(
      '--primary-card-color',
      '#56b26c',
    );
    document.documentElement.style.setProperty(
      '--primary-card-color-contrast-text',
      '#ffffff',
    );
  }
};
export default setTheme;
